// DirectAcquisitionsPage.js
import {ServiceIndividual, ServiceShowcaseR} from './Consultation';
import useApp from '../hooks/useApp';

const DirectAcquisitionsPage = () => {

    const {allFaqList} = useApp();

    const directAcquisitionsData = {
        activeLink: "/services/discreet-acquisitions",
        showcase: {
            title: "Discreet Domain Acquisitions",
            description1: "Secure the Right Domain — Quietly and Efficiently",
            description2: "Sometimes, the perfect domain name is already owned by someone else. Whether it’s for a rebrand, product launch, investment, or protecting your IP, acquiring it can be sensitive and complex.",
            buttonText1: "Request a Discreet Acquisition",
            buttonLink1: "/contact",
            buttonText2: null,
            buttonLink2: null,
            imageUrl: "https://via.placeholder.com/600/DDA0DD/000000?Text=Direct+Acquisition", // Replace
        },
        sections: [
            {
                title: "Why Choose Discreet Acquisition?",
                paragraphs: [
                    "Stay Anonymous: Avoid price inflation by keeping your identity and purpose confidential.",
                    "Protect Your Brand Strategy: Competitors won’t see your next move.",
                    "Negotiate Smartly: We handle all communication and negotiation with domain owners.",
                    "Speed & Efficiency: Our network and tools allow us to close deals quickly and quietly.",
                ],
            },
            {
                title: "Our Process",
                listItems: [
                    "Consultation: Tell us the domain(s) you're targeting and your budget.",
                    "Ownership Discovery: We track down the real owner, even when WHOIS is private.",
                    "Market Research: We assess fair market value based on current data and comparable sales.",
                    "Anonymous Outreach: We approach the owner without exposing your identity.",
                    "Negotiation: We work hard to secure the domain at the best possible price.",
                    "Secure Transfer: We handle payments and domain transfer through secure escrow services.",
                ],
            },
            {
                title: "Who is This For?",
                listItems: [
                    "Corporations and startups seeking a specific brand name",
                    "Investors building a strong domain portfolio",
                    "Businesses rebranding or expanding into new markets",
                    "Marketing and legal teams needing IP protection",
                ],
            },
            {
                title: "Success Through Experience",
                paragraphs: [
                    "With years of experience and deep industry connections, NameConnect has helped clients worldwide secure some of the most sought-after domain names. Our track record includes deals with Fortune 500 companies, global startups, and private investors — all managed under strict confidentiality.",
                ],
            },
            {
                title: "Ready to Acquire the Domain You Need?",
                paragraphs: [
                    "Let’s talk. Our discreet acquisition service ensures you get the domain you want — without unnecessary attention or inflated pricing.",
                ],
            },
            {
                title: "Contact Us Today",
                paragraphs: [
                    "For a confidential consultation.",
                ],
            },
        ],
    };

    return <ServiceIndividual serviceData={directAcquisitionsData} faqData={allFaqList["services/discreet-acquisitions"]} />;
};

export default DirectAcquisitionsPage;